import kagLogo from "../assets/kag-logo.png";

type Props = { className?: string };

export default function Logo({ className = "" }: Props) {
  return (
    <img
      src={kagLogo}
      alt="KAG Defense"
      className={`block w-[88px] sm:w-[100px] lg:w-[112px] h-auto ${className}`}
    />
  );
}
